import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import TimeOffTypePolicy from './TimeOffTypePolicy';

class TimeOffType extends DomainObject {
  id;
  name;
  typePolicy;
  createdAt;
  order;
  unit;
  includedInTimeTracking = true;

  _relations = {
    typePolicy: TimeOffTypePolicy
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      typePolicy: observable,
      createdAt: observable,
      order: observable,
      unit: observable,
      includedInTimeTracking: observable
    });

    this.merge(other);
  }
}

export default TimeOffType;
